/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateWithdrawalLimitsRequest { 
    currencyId?: number;
    minWithdrawalAmount?: number;
    dailyWithdrawalThreshold?: number;
    oneTimeWithdrawalThreshold?: number;
    verificationCode?: string | null;
}

